import {
    useCallback, useState,
} from 'react'

import SkyNetTable from 'app/shared-components/SkyNetTable'
import MultipleLocationSelector from 'app/shared-components/MultipleLocationSelector'
import Card from 'app/shared-components/Card'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useLabel from 'app/hooks/useLabel'

import useOrderManagementRoutes from 'app/SkyNetRoutes/hooks/useOrderManagementRoutes'

import orderRequests from 'app/requests/Order/Order.requests'
import preBookingsRequests from 'app/requests/Prebooking.requests'
import ordersToBeConfirmedConfig from './ordersToBeConfirmed.config'
import bookingsWaitingForPricing from './bookingsWaitingForPricing.config'
import {
    OrdersToBeConfirmedType,
} from './openBookings.types'
import useStyles from './OpenBookings.style'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]
const OpenBookings = () => {
    const {
        classes,
    } = useStyles()
    const Routes = useOrderManagementRoutes()
    const l = useLabel()

    const [
        filter,
        setFilter,
    ] = useState<{ id: number }[]>()

    const onRowClickToBeConfirmed = useCallback(({
        orderNumber,
    }: OrdersToBeConfirmedType): void => {
        Routes.CustomerOrders.Overview.navigate({
            params: {
                key: orderNumber,
            },
        })
    }, [Routes])

    const onRowClickWaitingForPricing = useCallback(({
        id,
    }: OrdersToBeConfirmedType): void => {
        Routes.PreBookings.Overview.navigate({
            params: {
                key: id,
            },
        })
    }, [Routes])

    const filterRequest = filter?.map(({
        id,
    }) => {
        return id
    })

    return (
        <div className={classes.root}>
            <div className={classes.headerTitle}>
                Open Bookings
            </div>
            <Card
                title="Filter by"
                className={classes.filterWrapper}
            >
                <MultipleLocationSelector
                    title={l('Order.originLocation')}
                    value={filter}
                    onChange={setFilter}
                />
            </Card>
            <div className={classes.tableWrapper}>
                <SkyNetTable
                    name={ordersToBeConfirmedConfig.name}
                    onRowClick={onRowClickToBeConfirmed}
                    tableControls={tableControls}
                    tableConfig={ordersToBeConfirmedConfig}
                    customUrl={orderRequests.openBookingsFilterRequest().url}
                    filter={{
                        originLocationId: filterRequest,
                    }}
                    showSearch
                />
            </div>
            <div className={classes.tableWrapper}>
                <SkyNetTable
                    name={bookingsWaitingForPricing.name}
                    onRowClick={onRowClickWaitingForPricing}
                    tableControls={tableControls}
                    tableConfig={bookingsWaitingForPricing}
                    customUrl={preBookingsRequests.openWithBookingFilterRequest().url}
                    filter={{
                        originServiceCenterId: filterRequest,
                    }}
                    showSearch
                />
            </div>
        </div>
    )
}

export default OpenBookings
